<template>
	<RejectedCookiesAlert v-if="!isLoadingScreen && isValidReservation" />
	<LoadingScreen v-if="isLoadingScreen" />
	<router-view v-else />
	<ToastWelcom />
	<ModalNotificationWelcom />
	<ModalPrivacy />
	<ModalReconnect />
	<CookieNotice v-if="!isLoadingScreen && shouldShowCookieNotice" />
</template>

<script>
import ToastWelcom from "@/components/toastWelcom/ToastWelcom";
import ModalNotificationWelcom from "@/components/modalNotification/ModalNotification";
import { mapGetters } from "vuex";
import LoadingScreen from "@/components/shared/LoadingScreen.vue";
import ModalPrivacy from "@/components/mods/modalPrivacy/ModalPrivacy.vue";
import ModalReconnect from "@/components/shared/ModalReconnect.vue";
import CookieNotice from "@/components/utils/CookieNotice.vue";
import RejectedCookiesAlert from "@/components/utils/RejectedCookiesAlert.vue";
import { cookieManager } from "@/service/cookieManager";

export default {
	name: "App",
	components: {
		RejectedCookiesAlert,
		CookieNotice,
		ModalReconnect,
		ModalPrivacy,
		LoadingScreen,
		ModalNotificationWelcom,
		ToastWelcom,
	},
	data() {
		return {
			showExitModal: false,
			preventExit: true,
			cookieManager, // Hacer cookieManager disponible en el componente
		};
	},
	computed: {
		...mapGetters("venue", ["resourceId"]),
		...mapGetters("config", ["isLoadingScreen"]),
		...mapGetters("menu", ["isValidReservation"]),

		shouldShowCookieNotice() {
			// Solo mostrar el CookieNotice si:
			// 1. No estamos en pantalla de carga
			// 2. Las cookies están disponibles
			// 3. No hay consentimiento previo
			return !this.isLoadingScreen && this.cookieManager?.cookiesAvailable && !this.cookieManager?.hasConsent();
		},
	},
};
</script>
